module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row margin-b-s margin-t-m padding-h-m"
  }, [_c('div', {
    staticClass: "small-6 columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('rsvpDetails.serviceType')))]), _vm._v(" "), _c('div', {
    staticClass: "value margin-b-s"
  }, [_vm._v(_vm._s(_vm.selectedService))]), _vm._v(" "), (_vm.showPickupType && !_vm.rsvp.isAsap) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('rsvpDetails.pickupType')) + "\n              "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enablePickupTypeEdit),
      expression: "enablePickupTypeEdit"
    }],
    staticClass: "editPickupType margin-l-s",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.editPickupType
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('rsvpDetails.edit')) + "\n                "), _c('icon', {
    attrs: {
      "name": "pencil",
      "scale": ".8"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPickupType && !_vm.rsvp.isAsap) ? _c('div', {
    staticClass: "value margin-b-s"
  }, [_c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditingPickupType && _vm.enablePickupTypeEdit),
      expression: "isEditingPickupType && enablePickupTypeEdit"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPickupType),
      expression: "selectedPickupType"
    }],
    staticClass: "field-select field-text pickupType",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPickupType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changePickupType($event)
      }]
    }
  }, _vm._l((_vm.legInfo.pickupTypes), function(puType, key) {
    return _c('option', {
      key: key,
      staticClass: "opt",
      attrs: {
        "name": puType.label,
        "data-pickuptype-fee": puType.fee
      },
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(puType.label + ' ' + _vm.pickupTypeFeeLabel(puType.fee, puType.label)))])
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditingPickupType),
      expression: "!isEditingPickupType"
    }]
  }, [_vm._v(_vm._s(_vm.pickupTypeLabel(_vm.pickupType)) + " " + _vm._s(_vm.pickupTypeFeeLabel(_vm.pickupFee, _vm.pickupType)))])]) : _vm._e(), _vm._v(" "), (!_vm.rsvp.isAsap) ? _c('div', {
    staticClass: "title"
  }, [(_vm.charter.enabled) ? _c('span', [_vm._v(_vm._s(_vm.$t('rsvpDetails.startDate')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('rsvpDetails.pickupDate')))])]) : _vm._e(), _vm._v(" "), (!_vm.rsvp.isAsap) ? _c('div', {
    staticClass: "value margin-b-s"
  }, [(_vm.charter.enabled) ? _c('span', [_vm._v(_vm._s(_vm.charter.startDate))]) : _c('span', [_vm._v(_vm._s(_vm.pickupDate))])]) : _vm._e(), _vm._v(" "), (_vm.charter.enabled) ? _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('rsvpDetails.endDate')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "value margin-b-s"
  }, [_c('span', [_vm._v(_vm._s(_vm.charter.endDate))])])])])]), _vm._v(" "), (!_vm.rsvp.isAsap) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('div', {
    staticClass: "service-info d-flex align-center"
  }, [_c('span', [_c('icon', {
    attrs: {
      "name": "users"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.passenger))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 columns end"
  }, [_c('div', {
    staticClass: "service-info d-flex align-center"
  }, [_c('span', [_c('icon', {
    attrs: {
      "name": "suitcase"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.luggage))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns padding-l-s"
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": _vm.serviceImg
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-m"
  }, [(_vm.showPaymentBreakdown) ? _c('div', {
    staticClass: "payment-breakdown"
  }, [_c('payment-summary-form', {
    attrs: {
      "flash": _vm.flash,
      "leg1": _vm.leg1,
      "leg2": _vm.leg2,
      "user": _vm.user,
      "currentLeg": _vm.currentLeg
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.charter.enabled) ? _c('div', {
    staticClass: "row padding-h-m"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-m"
  }, [_c('panel-location-details', {
    attrs: {
      "title": _vm.$t('rsvpDetails.pickup'),
      "details": _vm.charterDetails,
      "isDropoff": false,
      "currentLeg": _vm.currentLeg
    }
  })], 1)]) : _c('div', {
    staticClass: "row padding-h-m"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-m"
  }, [_c('panel-location-details', {
    attrs: {
      "title": _vm.$t('rsvpDetails.pickup'),
      "details": _vm.pickupDetails,
      "isDropoff": false,
      "currentLeg": _vm.currentLeg
    }
  })], 1)]), _vm._v(" "), (_vm.extraStop.length && !_vm.charter.enabled) ? _c('div', {
    staticClass: "row padding-h-m"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-m"
  }, [_c('panel-location-details', {
    attrs: {
      "title": _vm.$t('rsvpDetails.extraStop'),
      "details": _vm.extraStopDetails,
      "isExtraStop": true,
      "currentLeg": _vm.currentLeg
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.charter.enabled) ? _c('div', {
    staticClass: "row padding-h-m margin-b-m"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-m"
  }, [_c('panel-location-details', {
    attrs: {
      "title": _vm.$t('rsvpDetails.dropoff'),
      "details": _vm.dropoffDetails,
      "isDropoff": true,
      "currentLeg": _vm.currentLeg
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row padding-h-m margin-b-m"
  }, [_c('div', {
    staticClass: "medium-12 columns driver-notes"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('rsvpDetails.driverNotes')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driverNote),
      expression: "driverNote"
    }],
    attrs: {
      "placeholder": _vm.$t('rsvpDetails.inputNotes')
    },
    domProps: {
      "value": (_vm.driverNote)
    },
    on: {
      "change": _vm.saveDriverNotes,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.driverNote = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10681897", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10681897","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reservation/ReservationDetailsHeader.vue
// module id = 2035
// module chunks = 0